var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-c f-s-8"},[_vm._v("活动规则")]),_c('van-image',{staticClass:"m-t-05",attrs:{"src":_vm.imgUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }